import { Device } from 'types/devices';

export type DeviceProtocolVersion = 2 | 3 | null;

export const getDeviceProtocolVersion = (
  device: Device
): DeviceProtocolVersion => {
  const pushVersion = device.pushVer?.trim() || '';
  if (!/^(?:2|3)\.\d+(?:\.\d+)?[A-Za-z]?$/.test(pushVersion)) return null;
  return pushVersion.startsWith('2.') ? 2 : 3;
};
